module.exports = __webpack_public_path__ + "static/long-legs-23ccc2f095a074cbb722204f162a00a8.png";